// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"ba8f9d34","205":"800942a0","401":"2c1e98b7","484":"2bcd34ba","551":"183371dc","672":"8d416b4f","757":"9e2443de","842":"97ce1fd1","869":"530c4e94","974":"41256fc2"}[chunkId] + ".chunk.js";
};